<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="8">
                        <span>Selecciona Forma Pago</span>
                        <v-btn v-if="opc!='Nuevo'" @click="d_forma=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                        <v-btn v-else class="ml-5" x-small color="grey" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="mt-n5">
                        <v-radio-group v-model="opc" row>
                        <v-radio @click="clsInput()" label="Nuevo" value="Nuevo"></v-radio>
                        <v-radio @click="clsInput()" label="Modificar" value="Modificar"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row class="mt-7">
                    <v-col cols="12" md="4" class="mt-n7">
                        <v-text-field label="Forma" class='text-body-2' v-model="forma" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-n7">
                        <v-text-field type="number" label="Comisión (%)" class='text-body-2' v-model="comision" dense outlined rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="4" md="2" class="mt-n7">
                        <v-select class='text-caption' v-model="estado" :items="estados" label="Estado" dense outlined rounded></v-select>
                    </v-col>
                </v-row>
                <v-row class="mt-n10">
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn @click="clsInput()" small color="teal" dark rounded block><span class="text-caption">Limpiar</span></v-btn>
                    </v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn v-if="opc!='Nuevo'" @click="update_forma()" small color="teal" dark rounded block><span class="text-caption">Modificar</span></v-btn>
                        <v-btn v-else @click="save_forma()" small color="teal" dark rounded block><span class="text-caption">Grabar</span></v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_forma" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Forma de Pago
                    <v-spacer></v-spacer>
                    <v-icon @click="d_forma=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Forma</th>
                                    <th style="background-color: lightgrey;">Comisión</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handClients(item)" v-for="item in myFormaPago" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Forma }}</span></td>
                                    <td><span class="text-body-2">{{ item.Comision }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<script>
import axios from "axios";
export default {
    name: 'FormaPago',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        opc:'Nuevo',

        id_forma:0,
        forma:'',
        comision:'0',
        d_forma:false,
        myFormaPago:[],
        estados:['V','N'],
        estado:'V',

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(10);
            if(parseInt(this.bloqueo)!=0){
                await this.search_formas();
            };
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        clsInput(){
            this.id_forma=0,
            this.forma='';
            this.comision='0';
            this.estado='V';
        },
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                console.log('forma de pago',datos);
                if(datos[0].existe=='si'){
                    this.myFormaPago = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        handClients(item){
            console.log('item',item)
            this.id_forma=item.ID;
            this.forma=item.Forma;
            this.comision=parseFloat(item.Comision);
            this.d_forma=false
        },
        async exists_forma(){
            let result = false;
            const filter = this.myFormaPago.filter(res => res.Forma == this.forma);
            if(filter.length!=0){ result = true };
            return result
        },
        async save_forma(){
            this.loading=true;
            this.comision=''+this.comision;
            if(this.forma!=null && this.forma!='' && this.comision!=null && this.comision!=''){
                this.comision = this.comision.replaceAll(',','.');
                const exists = await this.exists_forma();
                if(!exists){
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'forma':this.forma,
                            'comision':this.comision,
                            'estado':this.estado
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/type/payment/',params,{headers});
                        const datos = res.data;
                        if(datos[0].existe=='si'){
                            await this.search_formas();
                            this.color_snack='success';
                            this.mensaje='Forma de pago ingresado con exito';
                            this.snack=true
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Forma de pago ingresado ya existe';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese forma de pago';
                this.snack=true
            };
            this.loading=false;
        },
        async update_forma(){
            this.loading=true;
            this.comision=''+this.comision;
            if(this.forma!=null && this.forma!='' && this.comision!=null && this.comision!=''){
                this.comision = this.comision.replaceAll(',','.');
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'id': this.id_forma,
                        'forma':this.forma,
                        'comision':this.comision,
                        'estado':this.estado
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/type/payment/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.search_formas();
                        this.color_snack='success';
                        this.mensaje='Forma de pago modificado con exito';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese forma de pago';
                this.snack=true
            };
            this.loading=false;
        },
        
    }
}
</script>
